import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Media, Row } from "reactstrap";
// import url from '../../../../../public/logo192.png'
import gifImage from "../../../../public/images/Congrats.gif";
import {
  getBaseUrl,
  daysNameEvaluation,
  monthNames,
} from "../../../../actions/utility";
import ChaptersAccordion from "./ChaptersAccordion";
import yTubeIcon from "../../../../public/images/youtubeIcon.svg";
import worksheetIcon from "../../../../public/images/google-docs.png";
import customerIcon from "../../../../public/images/customer-support.png";
import moment from "moment";
import "moment-timezone";
import plannerImage from "../../../../public/images/Picture2.jpg";
import {
  getTesstParameter,
  getReferralPrice,
} from "../../../../actions/feedActions";
import ScoresLeaderBoard from "../../../ReuseComponenets/ScoresLeaderBoard";
import $ from "jquery";

const StartClassFeed = (props) => {
  const { item, rewardPrice } = props;
  console.log("Start Class Feed", item);
  const { feed_data } = item;
  const [showChapters, setshowChapters] = useState(false);
  const [videoCount, setvideoCount] = useState("");
  const [isCopied, setisCopied] = useState(false);
  const [popup, setPopup] = useState(null);
  const [currentTime, setCurrentTime] = useState(new Date());
  const [encryptedId, setEncryptedId] = useState('');
  const [smileyArray, setsmileyArray] = useState([
    { id: 1, value: null },
    { id: 2, value: null },
    { id: 3, value: null },
    { id: 4, value: null },
    { id: 5, value: null },
    { id: 6, value: null },
    { id: 7, value: null },
    { id: 8, value: null },
  ]);


  useEffect(() => {

      // Extract the ID from the hash part of the URL
      const hash = window.location.hash;
      if (hash) {
        const encryptedId = hash.substring(2); // Remove the '#/' part
        setEncryptedId(encryptedId);
      }

    // Initialize the tooltip
    $('[data-toggle="tooltip"]').tooltip();
    
    // Apply custom style to tooltip
    $('[data-toggle="tooltip"]').on('shown.bs.tooltip', function () {
      const tooltipInner = document.querySelector('.tooltip-inner');
      if (tooltipInner) {
        tooltipInner.style.fontSize = '8px';
      }
    });

    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    if (isMobile) {
      $('[data-toggle="tooltip"]').on('click', function () {
        const element = $(this);
        element.tooltip('show');
        
        setTimeout(() => {
          element.tooltip('hide');
        }, 2000); // Hide tooltip after 2 seconds
      });
    }

  }, []);
  // // download file or documents from the posted feeds 

  const downloadFile = async (fileUrl, filename, defaultExtension) => {
    try {
        const response = await fetch(fileUrl);
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        
        const link = document.createElement('a');
        link.href = url;

        // Set the download attribute and filename
        const fileExtension = fileUrl.split('.').pop() || defaultExtension;
        const fullFilename = `${filename}.${fileExtension}`;
        link.setAttribute('download', fullFilename);
        
        // Trigger the download
        link.click();
    } catch (error) {
        console.error('Error downloading file:', error);
    }
};


  // console.log("JSON Format", item.feed_data && item.feed_data && JSON.parse(item.feed_data));
  const openFacebookPopup = () => {
    const width = 600;
    const height = 400;
    const left = window.innerWidth / 2 - width / 2;
    const top = window.innerHeight / 2 - height / 2;
    const url = "https://www.facebook.com";

    const options = `width=${width},height=${height},left=${left},top=${top}`;

    const popupWindow = window.open(url, "Facebook", options);
    setPopup(popupWindow);
  };
  const openInstaPopup = () => {
    const width = 600;
    const height = 400;
    const left = window.innerWidth / 2 - width / 2;
    const top = window.innerHeight / 2 - height / 2;
    const url = "https://www.instagram.com";

    const options = `width=${width},height=${height},left=${left},top=${top}`;

    const popupWindow = window.open(url, "Facebook", options);
    setPopup(popupWindow);
  };
  const openLinkedInPopup = () => {
    const width = 600;
    const height = 400;
    const left = window.innerWidth / 2 - width / 2;
    const top = window.innerHeight / 2 - height / 2;
    const url = "https://www.linkedIn.com";

    const options = `width=${width},height=${height},left=${left},top=${top}`;

    const popupWindow = window.open(url, "Facebook", options);
    setPopup(popupWindow);
  };

  const openWhatsAppPopup = (studentId) => {
    const content = `I found this service that has online tutors, check it out: \n \nhttps://lincolnmethod.com/?ref=${studentId}`;
    const url = `https://api.whatsapp.com/send?text=${encodeURIComponent(
      content
    )}`;
    window.open(url, "_blank");
  };

  if (item.feed_data && item.feed_data && JSON.parse(item.feed_data)) {
    var data = 0;
    const result = JSON.parse(item.feed_data).planner_topic?.map((item) => {
      return data + item.videos.length;
    });

    // console.log("Videos", result);
    // console.log(
    //   "Total Video",
    //   result &&
    //     result.reduce(function (a, b) {
    //       return a + b;
    //     })
    // ); // => 7
    // console.log("Total Video 2", [{ x: 1 }, { x: 2 }, { x: 4 }]); // => 7
    // console.log(
    //   "Total Video Function",
    //   JSON.parse(item.feed_data).planner_topic &&
    //     JSON.parse(item.feed_data).planner_topic.reduce((a, b) => ({
    //       videos: a.videos.length + b.videos.length,
    //     }))
    // ); // => 7
  }

  const TDate = (scheduledTime) => {
    var ToDate = new Date();

    if (new Date(scheduledTime).getTime() <= ToDate.getTime()) {
      // alert("The Date must be Bigger or Equal to today date");
      return true;
    }
    return false;
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date());
    }, 60000); // Update current time every minute

    return () => clearInterval(interval); // Cleanup interval on component unmount
  }, []);

  const isTimeValid = (passedTime) => {
    const passedDateTime = new Date(passedTime);
    const differenceInMinutes = Math.floor((currentTime - passedDateTime) / (1000 * 60));
    return differenceInMinutes < 42;
  };

  const dateAfter1Day = (scheduledTime) => {
    var feedDate = new Date(scheduledTime);
    var currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);
    if (currentDate > feedDate) {
      return false;
    } else {
      return true;
    }
  };

  const redirectToTest = (testId, chapterId, programId, studentId) => {
    debugger;
    getTesstParameter(testId, studentId)
      .then((res) => {
        window.open(
          `https://dashboard.lincolnmethod.com/signin?continue_session=true&student_id=${studentId}&program=${programId}&test_taken=${res.data}&testid=${testId}&assessid=${chapterId}&practice=0&txt_program=${programId}`,
          "_blank"
        );
        debugger;
      })
      .catch((err) => {});
  };

  const getVideosCount = () => {
    var reduced = JSON.parse(item.feed_data).planner_topic?.reduce(function (
      r,
      a
    ) {
      return r + a.videos.length;
    },
    0);

    if (
      typeof reduced != "undefined" &&
      typeof reduced != "null" &&
      reduced != 0
    ) {
      return <span>, {reduced} Videos</span>;
    } else return null;
  };

  const getWorksheetsCount = () => {
    var reduced = JSON.parse(item.feed_data).planner_topic?.reduce(function (
      r,
      a
    ) {
      return r + a.worksheet.length;
      //    ^^^ use the last result without property
    },
    0);

    if (
      typeof reduced != "undefined" &&
      typeof reduced != "null" &&
      reduced != 0
    ) {
      return <span>, {reduced} Worksheets</span>;
    } else return null;
  };
  console.log("Date in browser", new Date().getDay());
  var attendaceData = null;
  if (item.feed_data_update) {
    attendaceData = JSON.parse(item.feed_data_update);
  }
  const currentTimeZone = moment.tz.guess();
  console.log("TIme Zone", moment.tz.guess());

  const rendringSmileys = (data, value) => {
    var newTemp = smileyArray.filter((item) => item.id == data.id);
    newTemp[0].value = value;
    setsmileyArray([...smileyArray, newTemp]);
    debugger;
  };

  const copyFunc = (studentId) => {
    navigator.clipboard.writeText(
      `https://lincolnmethod.com/?ref=${studentId}`
    );
    setisCopied(true);

    setTimeout(() => {
      setisCopied(false);
    }, 2000);
  };

  return (
    <Card
      style={{
        marginBottom: "2vh",
        border: "1px #ccc solid",
        textAlign: "left",
      }}
      className="homeSection"
      id={item.user_feedid}
    >
      <CardBody style={{ padding: 0 }}>
        <div style={{ padding: "1.25rem" }}>
          <div className="d-flex tutorImageSection">
            <div>
              <img
                className="mt-1"
                src={`https://lincolnmethod.s3.us-east-1.amazonaws.com/profileImages/${item.teacher_image}`}
                width="40"
                height="40"
              />
            </div>
            <div className="ml-2">
              <label>
                {item.teacher_name}
                <strong> started </strong> class
              </label>
              <br />
              <span className="gradeName text-primary truncate">
                {item.course_name}
              </span>
              <span style={{ fontSize: 10 }} data-toggle="tooltip" data-placement="bottom" title={item.created_at}>
                {moment
                  .tz(item.created_at, "Asia/Karachi")
                  .tz(currentTimeZone)
                  .fromNow()}
              </span>
            </div>
          </div>
        </div>
        <Row style={{ margin: 0 }}>
          <Col
            className="classStartFeedImg"
            style={{ backgroundImage: "url(" + plannerImage + ")" }}
          >
            <Row className="">
              <Col xs={6}>
                <div className="details right">
                  <label className="mb-0" style={{ fontSize: "12px" }}>
                    <span
                      className="dayCircle"
                      style={
                        moment(item.created_at).format("dddd") == "Wednesday"
                          ? { background: "#B30493" }
                          : { background: "#F6A00E" }
                      }
                    >
                      {moment(item.created_at).format("dddd")}
                    </span>{" "}
                    <br /> <h5 className="mt-2"> Class started </h5>
                  </label>
                  <div className="hrLineFeed" />
                  {/* <hr /> */}
                  {JSON.parse(feed_data)?.planner_topic?.length > 0 && (
                    <>
                      <p className="mt-2">We will cover:</p>
                      <label style={{ fontSize: "12px" }}>
                        {JSON.parse(feed_data)?.planner_topic?.length > 0
                          ? JSON.parse(feed_data)?.planner_topic?.length
                          : "0"}{" "}
                        Topic {getWorksheetsCount()}
                        {getVideosCount()}
                      </label>
                    </>
                  )}
                </div>
              </Col>
              <Col xs={6} className="text-right">
              <div className="referraLinkBtn2"  style={{textAlign: 'right !important', display: 'flex', justifyContent: 'flex-end'}}>
                  <button
                    className={
                      isCopied
                        ? "btn btn-sm btn-success d-flex align-items-center"
                        : "btn btn-sm btn-warning d-flex align-items-center"
                    }
                    onClick={() => {
                      $("#referralPopup").modal("show");
                    }}
                    style={{ fontSize: 12 }}
                  >
                  <div style={{ marginRight: '0.5em' }}>Invite a friend</div>
  <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 501.2 647.8"
      style={{ enableBackground: 'new 0 0 501.2 647.8', height: "3em"}}
      xmlSpace="preserve"
      className="svg-icon"
    >
      <style>
        {`
          .st0{fill:#135D7A;stroke:#135D7A;stroke-width:11;stroke-miterlimit:10;}
          .st1{fill:#135D7A;stroke:#135D7A;stroke-width:22;stroke-miterlimit:10;}
          .st2{fill:none;stroke:#135D7A;stroke-width:12;stroke-miterlimit:10;}
          .st3{fill:#231F20;}
          .st4{fill:none;stroke:#135D7A;stroke-width:31;stroke-miterlimit:10;}
        `}
      </style>
      <path className="st0" d="M290.2,86.4h-79.1c-1.8,0-3.1-1.5-3.1-3.1v-10c0-1.8,1.5-3.1,3.1-3.1h79.1c1.8,0,3.1,1.5,3.1,3.1v10
        C293.2,85.1,292,86.4,290.2,86.4z"/>
      <rect x="93.2" y="515.9" className="st1" width="314.8" height="9.2"/>
      <circle className="st2" cx="250.6" cy="574.4" r="23.5"/>
      <path className="animated-icon st3" d="M252.4,307.3c-30.3-3.5-34.4-17.9-34.4-32.6c0-17.9,14.7-32.6,32.6-32.6s32.6,14.7,32.6,32.6
        c0,9.3,7.3,16.6,16.6,16.6s16.6-7.3,16.6-16.6c0-30.6-21-56.1-49.2-63.6v-7.9c0-9.3-7.3-16.6-16.6-16.6c-9.3,0-16.6,7.3-16.6,16.6
        v7.9c-28.1,7.3-49.2,33.1-49.2,63.6c0,21.7,8.3,59.1,63.9,65.7c30.3,3.5,34.4,17.9,34.4,32.6c0,17.9-14.7,32.6-32.6,32.6
        c-17.9,0-32.6-14.7-32.6-32.6c0-9.3-7.3-16.6-16.6-16.6c-9.3,0-16.6,7.3-16.6,16.6c0,30.6,21,56.1,49.2,63.6v7.9
        c0,9.3,7.3,16.6,16.6,16.6c9.3,0,16.6-7.3,16.6-16.6v-7.9c28.1-7.3,49.2-33.1,49.2-63.6C316.1,351.4,307.9,314.1,252.4,307.3z"/>
      <g>
        <path className="st4" d="M392.4,627.4H108.8c-22.4,0-40.5-18.1-40.5-40.5v-526c0-22.4,18.1-40.5,40.5-40.5h283.6
          c22.4,0,40.5,18.1,40.5,40.5v526C432.9,609.3,414.8,627.4,392.4,627.4z"/>
      </g>
    </svg>
                  </button>
                </div> 
  
              </Col>
            </Row>
          </Col>
        </Row>
        {item.is_zoom == 1 ? (
          <>
            {TDate(item.scheduled_date_time) ? (
              <div className="mt-3">
                <label className="font-weight-bold">
                  Your class was on:
                </label>
                <p>
                  Date:{" "}
                  {
                    daysNameEvaluation[
                      new Date(item.scheduled_date_time).getDay()
                    ]
                  }{" "}
                  {new Date(item.scheduled_date_time).getDate()}{" "}
                  {monthNames[new Date(item.scheduled_date_time).getMonth()]}{" "}
                  <br />
                  Time:{" "}
                  {new Date(item.scheduled_date_time).toLocaleTimeString(
                    "en-US",
                    {
                      hour: "2-digit",
                      minute: "2-digit",
                    }
                  )}{" "}
                  <br />
                  Teacher: {item.teacher_name}{" "}
                </p>
              </div>
            ) : (
              <>
                <div className="mt-3">
                  <label className="font-weight-bold">
                    Your demo class is on:
                  </label>
                  <p>
                    Date:{" "}
                    {
                      daysNameEvaluation[
                        new Date(item.scheduled_date_time).getDay()
                      ]
                    }{" "}
                    {new Date(item.scheduled_date_time).getDate()}{" "}
                    {monthNames[new Date(item.scheduled_date_time).getMonth()]}{" "}
                    <br />
                    Time:{" "}
                    {new Date(item.scheduled_date_time).toLocaleTimeString(
                      "en-US",
                      {
                        hour: "2-digit",
                        minute: "2-digit",
                      }
                    )}{" "}
                    <br />
                    Teacher: {item.teacher_name}{" "}
                  </p>
                </div>
                <button
                  className="btn btn-success zoomBtn"
                  onClick={() => window.open(item.zoomlink, "_blank")}
                >
                  Click to join your class online
                </button>
              </>
            )}
          </>
        ) : null}
        {item.feed_label == "start_class" ? (
          <div style={{ padding: ".5rem 1.25rem" }}>
            {JSON.parse(feed_data).planner_topic?.length > 0 ? (
              <label>Topic(s) covered in class today:</label>
            ) : null}
            <br />
            {JSON.parse(feed_data).planner_topic &&
              JSON.parse(feed_data).planner_topic.map((planner, index) => (
                <>
                  <div className="d-flex">
                    <i className="fa fa-commenting mr-2 text-success fa-2x"></i>
                    <div>
                      <label className="mb-0 font-weight-bold">
                        {" "}
                        {planner.topicName}
                      </label>
                      <p
                        className="text-italic"
                        style={{ fontSize: 12, color: "#c1c1c1" }}
                      >
                        (Chapter: {planner.chapterName})
                      </p>
                    </div>
                  </div>
                  <div className="">
                    {planner.worksheet.length > 0 && (
                      <label>Worksheet(s):</label>
                    )}
                    <div className="">
                      {planner.worksheet.map((worksheet, index2) => (
                        <div className="container" key={index2}>
                          <div className="row">
                            <div className="col-1 p-0" key={index2}>
                              <Media
                                width={20}
                                height={20}
                                object
                                src={worksheetIcon}
                                alt={worksheetIcon}
                              />
                            </div>
                            <div className="col-8 p-0">
                              <label className="">
                                <a href={worksheet.link} onClick={(e)=> {e.preventDefault(); downloadFile(worksheet.link, worksheet.label, 'txt')}}>
                                  {worksheet.label}
                                </a>                        
                              </label>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="">
                    {planner.videos.length > 0 && <label>Video(s):</label>}
                    <div className="container">
                      <div className="row">
                        {planner.videos.map((video, index3) => (
                          <>
                            <div className="col-1 p-0" key={index3}>
                              <Media
                                width={20}
                                height={20}
                                object
                                src={yTubeIcon}
                                alt={yTubeIcon}
                              />
                            </div>
                            <div className="col-11 p-0">
                              <label className="">
                                <a href={video.video_url} target="_blank">
                                  {video.video_caption}
                                </a>
                              </label>
                            </div>
                          </>
                        ))}
                      </div>
                    </div>
                  </div>

                  {planner.has_questions ? (
                    <div className="text-right">
                      {/* <label style={{ color: "#218838" }} className="mr-2">
                      Score
                    </label>{" "}
                    <label className="percent">
                      {topicsData[topics]["beforeScore"]}%
                    </label>{" "} */}
                      {/* <a
                      target="__blank"
                      href={`https://dashboard.lincolnmethod.com/signin?continue_session=true&student_id=${item.student_id}&prog_id=${item.prog_id}&assess_id=${planner.chapterId}&test_id=${planner.topicId}`}
                      className=""
                    > */}
                      <button
                        onClick={() =>
                          redirectToTest(
                            planner.topicId,
                            planner.chapterId,
                            item.prog_id,
                            item.student_id
                          )
                        }
                        className="btn btn-lg"
                        style={{
                          minHeight: 45,
                          background: "#D7E7F7",
                          color: "#3D3D3D",
                          fontSize: 14,
                        }}
                      >
                        {planner?.otherStudents.length > 0 && planner?.otherStudents?.some((obj) =>
                          Object.values(obj)?.includes(item?.student_name)
                        )
                          ? "Re-do Quiz"
                          : "Start Quiz"}
                      </button>
                      {/* </a> */}
                    </div>
                  ) : null}
                  <ScoresLeaderBoard scoresData={planner?.otherStudents} />
                  <hr />
                </>
              ))}
            <br />

            {isTimeValid(item?.created_at) ? (
              <button
                className="btn btn-success zoomBtn"
                onClick={() => window.open(item.zoomlink, "_blank")}
              >
                Click to join your class online
              </button>
            ) : null}
          </div>
        ) : null}

        {attendaceData ? (
          <div style={{ padding: "1.25rem" }}>
            <div style={{ background: "#EDF0F3", padding: 10 }}>
              {attendaceData.isPresent ? (
                <>
                  <label>Your performance today:</label>

                  <div className="row">
                    <div className="col-3 text-center">
                      {attendaceData?.onTime ? (
                        <i className="smileSelect far fa-grin"></i>
                      ) : (
                        <i className="far fa-meh sadSelect"></i>
                      )}{" "}
                      <br />
                      <p
                        className="text-italic"
                        style={{ fontSize: 10, color: "#000" }}
                      >
                        On Time
                      </p>
                    </div>
                    <div className="col-3 text-center">
                      {attendaceData?.attentive ? (
                        <i className="smileSelect far fa-grin"></i>
                      ) : (
                        <i className="far fa-meh sadSelect"></i>
                      )}{" "}
                      <br />
                      <p
                        className="text-italic"
                        style={{ fontSize: 10, color: "#000" }}
                      >
                        Attentive
                      </p>
                    </div>
                    <div className="col-3 text-center">
                      {attendaceData?.homeworkCompletion ? (
                        <i className="smileSelect far fa-grin"></i>
                      ) : (
                        <i className="far fa-meh sadSelect"></i>
                      )}{" "}
                      <br />
                      <p
                        className="text-italic"
                        style={{ fontSize: 10, color: "#000" }}
                      >
                        Homework Completion
                      </p>
                    </div>
                    <div className="col-3 text-center">
                      {attendaceData?.classworkCompletion ? (
                        <i className="smileSelect far fa-grin"></i>
                      ) : (
                        <i className="far fa-meh sadSelect"></i>
                      )}{" "}
                      <br />
                      <p
                        className="text-italic"
                        style={{ fontSize: 10, color: "#000" }}
                      >
                        Classwork Completion
                      </p>
                    </div>
                  </div>
                </>
              ) : (
                <label className="text-danger">You were marked absent</label>
              )}
            </div>
          </div>
        ) : null}

        {item.is_practice == 1 ? (
          <>
            <button
              className={
                showChapters
                  ? "btn takeTest mt-3"
                  : "btn btn-success zoomBtn mt-3"
              }
              onClick={() => setshowChapters(!showChapters)}
            >
              {showChapters
                ? "Select a chapter and a topic below"
                : "Take a practice test while you wait"}
            </button>
            {showChapters ? (
              <ChaptersAccordion
                programId={item.prog_id}
                studentId={item.student_id}
              />
            ) : null}
          </>
        ) : null}
      </CardBody>
      <div className="zoomSection">
      </div>

      <div className="modalForZoomLink">
        <div className="modal fade" tabIndex="-1" role="dialog" id="referralPopup">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-body">
                <div className="text-center">
                  <i className="fas fa-share-alt fa-2x text-success"></i>
                  <h5 className="font-weight-bold mt-1">
                    Share your unique link
                  </h5>
                  <div className="text-center">
                    <p>{`https://lincolnmethod.com/?ref=${encryptedId}`}</p>
                    <button
                      className="btn btn-success btn-sm"
                      onClick={() => copyFunc(encryptedId)}
                    >
                      {isCopied ? "Copied!" : "Copy"}
                    </button>

                    <h5 className="font-weight-bold mt-1">
                      Share on social media
                    </h5>
                    <div className="d-flex justify-content-center">
                      <button className="fbBtn mx-2" onClick={openFacebookPopup}>
                        <i className="fa fa-facebook" />
                      </button>

                      <button className="instaBtn mx-2" onClick={openInstaPopup}>
                        <i className="fa fa-instagram" />
                      </button>
                      <button
                        className="linkedInBtn mx-2"
                        onClick={openLinkedInPopup}
                      >
                        <i className="fa fa-linkedin" />
                      </button>
                      <button
                        className="whatsappInBtn mx-2"
                        onClick={() => openWhatsAppPopup(encryptedId)}
                      >
                        <i className="fa fa-whatsapp" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default StartClassFeed;
